import React from "react";
import {
  Card,
  Label,
  AdditionalInformationTitle,
} from "styles/pages/staples-bulk-orders";

const OrderAdditionalInfo = ({ data }) => (
  <div>
    <Card>
      <AdditionalInformationTitle>
        Additional Information
      </AdditionalInformationTitle>
      {data?.map((d, i) => (
        <Label
          key={`${d}_${i}`}
          showBackgroundColor={
            d?.includes("Logo File Name") ||
            d?.includes("Logo Description") ||
            d?.includes("Decoration Method") ||
            d?.includes("Placement") ||
            d?.includes("Item")
          }
        >
          {d}
        </Label>
      ))}
    </Card>
  </div>
);

export default OrderAdditionalInfo;
